export { Image } from './image'



// WEBPACK FOOTER //
// ./src/app/shared/components/image/index.ts